import { Payments } from "./Payments";

export class ConvenienceFeeRequest {
    PrimaryCustomerId: string;
    Payments?: Payments[] = [];
}